module.exports = __webpack_public_path__ + "img/clogo.87afa62d.png";